import React from 'react';

const RefundRequestList = React.lazy(() => import('./RefundRequestList'));

export default [
  { path: 'refund-requests', element: <RefundRequestList /> }
];
